/* Satva Farm: free-delivery progress bar for the cart drawer and cart page.
   Config comes from the announcement bar section (window.SatvaFD). Amounts are in paise. */
(function () {
  'use strict';
  var CFG = window.SatvaFD || {};
  var THRESHOLD = CFG.threshold || 75000;
  var FEE = CFG.fee || 15000;
  var MAX_ADDON = CFG.maxAddon || 30000;
  var lastKey = null;
  var timer = null;
  var recCache = {};

  function money(c) {
    var r = c / 100;
    return '₹' + r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function injectCss() {
    if (document.getElementById('sfd-css')) return;
    var s = document.createElement('style');
    s.id = 'sfd-css';
    s.textContent =
      '.sfd{padding:1.2rem 0 1.4rem;margin:0 0 1rem;border-bottom:1px solid rgba(0,0,0,.08);font-size:1.4rem;line-height:1.4}' +
      '.sfd__msg{margin:0 0 .8rem}' +
      '.sfd__track{height:.8rem;border-radius:.4rem;background:#e6ede1;overflow:hidden}' +
      '.sfd__track span{display:block;height:100%;background:#3d7a2a;border-radius:.4rem;transition:width .4s ease}' +
      '.sfd__adds-h{margin:1.2rem 0 .6rem;font-size:1.2rem;opacity:.75}' +
      '.sfd__adds{list-style:none;margin:0;padding:0 0 .4rem;display:flex;gap:.8rem;overflow-x:auto}' +
      '.sfd__add{flex:0 0 auto;width:19rem;display:flex;gap:.8rem;align-items:center;border:1px solid rgba(0,0,0,.1);padding:.6rem;background:#fff}' +
      '.sfd__add img{width:4.4rem;height:4.4rem;object-fit:cover;flex:0 0 auto}' +
      '.sfd__add-b{min-width:0;flex:1}' +
      '.sfd__add-t{font-size:1.2rem;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:inherit;text-decoration:none}' +
      '.sfd__add-p{font-size:1.2rem;font-weight:600}' +
      '.sfd__btn{flex:0 0 auto;border:1px solid #3d7a2a;background:#3d7a2a;color:#fff;font-size:1.2rem;padding:.5rem .9rem;cursor:pointer;font-family:inherit}' +
      '.sfd__btn[disabled]{opacity:.6;cursor:default}';
    document.head.appendChild(s);
  }

  function containers() {
    var out = [];
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) out.push({ el: inner, after: inner.querySelector('.drawer__header') });
    var blocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (blocks) out.push({ el: blocks, after: null });
    return out;
  }

  function getAddons(cart, remaining) {
    if (!cart.items.length) return Promise.resolve([]);
    var pid = cart.items[0].product_id;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var p = recCache[pid];
    if (!p) {
      var base = '/recommendations/products.json?product_id=' + pid + '&limit=10&intent=';
      p = recCache[pid] = Promise.all([
        fetch(base + 'complementary').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; }),
        fetch(base + 'related').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; })
      ]).then(function (res) { return (res[0].products || []).concat(res[1].products || []); });
    }
    return p.then(function (list) {
      var seen = {};
      var picks = [];
      list.forEach(function (prod) {
        if (picks.length >= 3 || seen[prod.id] || inCart[prod.id] || !prod.available) return;
        var v = (prod.variants || []).filter(function (x) { return x.available; })[0];
        if (!v || v.price > MAX_ADDON) return;
        seen[prod.id] = true;
        picks.push({ id: v.id, title: prod.title, url: prod.url, price: v.price, img: prod.featured_image });
      });
      return picks;
    });
  }

  function barHtml(cart, addons) {
    var total = cart.total_price;
    var rem = THRESHOLD - total;
    var pct = Math.max(4, Math.min(100, Math.round(total / THRESHOLD * 100)));
    var msg = rem > 0
      ? 'Add <strong>' + money(rem) + '</strong> more for <strong>free delivery</strong> (saves ' + money(FEE) + ')'
      : '🎉 You’ve unlocked <strong>free delivery</strong>';
    var h = '<p class="sfd__msg">' + msg + '</p><div class="sfd__track" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
    if (rem > 0 && addons.length) {
      h += '<p class="sfd__adds-h">Popular add-ons</p><ul class="sfd__adds" role="list">' + addons.map(function (a) {
        return '<li class="sfd__add">' + (a.img ? '<img src="' + esc(sized(a.img, 120)) + '" alt="" loading="lazy" width="44" height="44">' : '') +
          '<div class="sfd__add-b"><a class="sfd__add-t" href="' + esc(a.url) + '">' + esc(a.title) + '</a><span class="sfd__add-p">' + money(a.price) + '</span></div>' +
          '<button type="button" class="sfd__btn" data-sfd-add="' + a.id + '" aria-label="Add ' + esc(a.title) + ' to cart">+ Add</button></li>';
      }).join('') + '</ul>';
    }
    return h;
  }

  function paint(cart, addons) {
    var html = cart.item_count > 0 ? barHtml(cart, addons) : '';
    containers().forEach(function (c) {
      var bar = c.el.querySelector(':scope > [data-sfd]');
      if (!html) { if (bar) bar.remove(); return; }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'sfd';
        bar.setAttribute('data-sfd', '');
        bar.setAttribute('role', 'status');
        if (c.after && c.after.parentNode === c.el) c.after.insertAdjacentElement('afterend', bar);
        else c.el.insertBefore(bar, c.el.firstChild);
      }
      bar.innerHTML = html;
    });
  }

  function missing() {
    return containers().some(function (c) { return !c.el.querySelector(':scope > [data-sfd]'); });
  }

  function refresh(force) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var key = cart.total_price + ':' + cart.item_count;
        if (!force && key === lastKey && !missing()) return;
        lastKey = key;
        var rem = THRESHOLD - cart.total_price;
        var addonsP = (rem > 0 && cart.item_count > 0) ? getAddons(cart, rem) : Promise.resolve([]);
        return addonsP.then(function (addons) { paint(cart, addons); });
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(false); }, 250);
  }

  function addItem(btn) {
    var id = +btn.getAttribute('data-sfd-add');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.disabled = false; btn.textContent = '+ Add'; alert(res.j.description || 'Could not add this item.'); return; }
        var drawer = document.querySelector('cart-drawer');
        if (window.location.pathname.indexOf('/cart') === 0 || !drawer || typeof drawer.renderContents !== 'function' || !res.j.sections) {
          window.location.reload();
          return;
        }
        drawer.renderContents(res.j);
        refresh(true);
      })
      .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
  }

  function init() {
    injectCss();
    refresh(true);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sfd-add]');
      if (b) { e.preventDefault(); addItem(b); }
    });
    var watch = ['cart-drawer', '#main-cart-items', '#main-cart-footer', '#cart-icon-bubble'];
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType !== 1) t = t.parentElement;
        if (!t || (t.closest && t.closest('[data-sfd]'))) continue;
        schedule();
        return;
      }
    });
    watch.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) obs.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
